import React, { useState, useEffect } from 'react';

function VideoPlayer(props) {
    const { metadataCallback, ...rest } = props;
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (window.videojs) {
            setLoaded(true);
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://vjs.zencdn.net/8.23.4/video.min.js';
        script.async = true;
        script.onload = () => setLoaded(true);
        script.onerror = () => setError(true);
        document.body.appendChild(script);
    }, []);

    if (error) return <div>Failed to load player</div>;
    if (!loaded) return <div>Player is loading</div>;

    return (
        <div className="video-player">
            <link rel="stylesheet" href="https://vjs.zencdn.net/8.23.4/video-js.css" />
            <VideoJsPlayer {...rest} metadataCallback={metadataCallback} />
        </div>
    );
}

class VideoJsPlayer extends React.Component {
    componentDidMount() {
        // instantiate Video.js
        const {metadataCallback, playbackUrl, contentType } = this.props
        this.player = window.videojs('my-player');
        this.player.fluid(true)
        this.player.responsive(true)
        this.player.ready(function () {
            const isDev = process.env.NODE_ENV === 'development';
            let url = playbackUrl;
            if (isDev && playbackUrl.startsWith('https://dist.esatsang.live')) {
                url = playbackUrl.replace('https://dist.esatsang.live', '/live-stream');
            }
            this.src({
                src: url,
                type: 'application/x-mpegURL'
            })
            this.on('loadedmetadata',function() {
                if(metadataCallback != null) {
                    metadataCallback()
                }
            })
        });
    }

    // destroy player on unmount
    componentWillUnmount() {

        if (this.player) {
            this.player.dispose()
        }
    }

    // wrap the player in a div with a `data-vjs-player` attribute
    // so videojs won't create additional wrapper in the DOM
    // see https://github.com/videojs/video.js/pull/3856
    render() {
        const { contentType, playbackUrl, metadataCallback, ...domProps } = this.props;
        return (
            <div>
                <div data-vjs-player>
                    {
                        contentType === "audio" ?
                            <audio id="my-player" {...domProps} className="video-js vjs-default-skin vjs-big-play-centered" /> :
                            <video id="my-player" {...domProps} className="video-js vjs-default-skin vjs-big-play-centered" />
                    }

                </div>
            </div>
        )
    }
}

export default VideoPlayer;
